import { Color } from "../enums/Color";
import { Font } from "../enums/Font";

export const scamAlertBanner ={
    mobile: {
        width: "100vw",
        background: Color.Linen,
        display:"flex",
        flexDirection:"column",
        justifyContent: "center",
        alignItems: "center",
        header: {
            fontSize: "3.00vw",
            color: Color.Red,
            fontFamily: Font.Poppins,
            marginTop: "1vw",
            marginLeft: "2.5vw",
            paddingRight: "6vw"
        },
        bodyMessage: {
            color: Color.Red,
            fontFamily: Font.Poppins,
            fontSize: "3.00vw",
            marginLeft: "2.5vw",
            paddingRight: "4vw",
            marginBottom: "2vw"
        },
        boldText: {
            fontWeight: "bold" as "bold",
        },
        boldTextAndUnderline: {
            fontWeight: "bold" as "bold",
            textDecoration: "underline"
        },
        closeIcon: {
            position: "absolute" as "absolute",
            right: "1vw",
            top: "1vw"
        }
    },
    desktop: {
        width: "100%",
        height: "3.81vw", 
        paddingTop: "0.3vw",
        paddingBottom: "0.3vw",      
        header: {
            marginTop: "0vw",
            fontSize: "0.93vw",
            paddingRight: "0"
        },
        bodyMessage: {
            fontSize: "0.93vw",
            marginBottom: "0vw",
            paddingRight: "0"
        },
        closeIcon: {
            right: "0.5vw",
            top: "0.5vw",
            cursor: "pointer"
        }
    }
}